
class Video {
  constructor() {
    this._init();
  }

  private _init() {
    const buttons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.video__button');

    buttons.forEach((button: HTMLButtonElement) => {
      button.addEventListener('click', () => {
        const iframeSrc = button.dataset.videoSrc;
        if (!iframeSrc) {
          return;
        }

        const iframe: HTMLIFrameElement = document.createElement('iframe');

        iframe.setAttribute('src', iframeSrc + '?autoplay=1');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', 'true');

        if (button.parentNode) {
          button.parentNode.replaceChild(iframe, button);
        }

      }, { once: true });
    });
  }


}

export const video = new Video();
